"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var children = _ref.children,
      secondary = _ref.secondary,
      destructive = _ref.destructive,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick;
  var classes = ['shx-button'];

  if (secondary) {
    classes.push('shx-button--secondary');
  }

  if (destructive) {
    classes.push('shx-button--destructive');
  }

  return /*#__PURE__*/_react.default.createElement("button", {
    className: classes.join(' '),
    disabled: disabled,
    onClick: onClick
  }, children);
};

Button.propTypes = {
  children: _propTypes.default.node.isRequired,
  secondary: _propTypes.default.bool,
  destructive: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired
};
var _default = Button;
exports.default = _default;